import ModulesReducer from './reducers/modules-reducer';
import { configureStore } from '@reduxjs/toolkit';
import AuthInfoReducer from './reducers/authInfoReducer';
import ModuleRouteReducer from './reducers/module-route-info-reducer';
import { useDispatch } from 'react-redux';
import DataInstanceReducer from './reducers/DataInstanceReducer';
import notificationMessageReducer from './reducers/notificationMesageReducer';
import FormConfigReducer from './reducers/form-config-reducer';
import PrevContextReducer from './reducers/PrevContextReducer';
import RequiredFieldsReducer from './reducers/requiredFieldsReducer';
import { enableMapSet } from 'immer';
import DialogsViewsState from './reducers/dialogViewsReducer';
import PageViewsReducer from './reducers/pageViewsReducer';
import ViewStateLoadedReducer from './reducers/viewStateLoadedReducer';
import SidebarViewsStateReducer from './reducers/sidebarViewsReduser';
import themeEditorReducer from './reducers/themeEditorReducer';
import { navigationSyncMiddleware } from './middleware/navigationSyncMiddleware';
import NavigationSyncReducer from './reducers/navigationSyncReducer';
import { authSyncMiddleware } from './middleware/authSyncMiddleware';
import { cacheInvalidationMiddleware } from './middleware/cacheInvalidationMiddleware';
import WindowViewStateReducer from './reducers/WindowViewStateReducer';
import PermissionsRuntimeReducer from './reducers/permissionsRuntimeState';
import { permissionsRuntimeListenerMiddleware } from './middleware/permissionsRuntine.listener';

enableMapSet();

const store = configureStore({
  reducer: {
    modules: ModulesReducer,
    authInfo: AuthInfoReducer,
    moduleRouteInfo: ModuleRouteReducer,
    themeEditor: themeEditorReducer,
    dataInstance: DataInstanceReducer,
    notificationMessage: notificationMessageReducer,
    pageConfig: FormConfigReducer,
    prevContext: PrevContextReducer,
    formRequiredFields: RequiredFieldsReducer,
    dialogViewsState: DialogsViewsState,
    sidebarViewsState: SidebarViewsStateReducer,
    viewStateLoaded: ViewStateLoadedReducer,
    pageViewStack: PageViewsReducer,
    navigationSync: NavigationSyncReducer,
    windowViewState: WindowViewStateReducer,
    permissionsRuntime: PermissionsRuntimeReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      navigationSyncMiddleware,
      authSyncMiddleware,
      cacheInvalidationMiddleware,
      permissionsRuntimeListenerMiddleware.middleware,
    ),
});

export type AppDispatch = typeof store.dispatch;

export type RootState = ReturnType<typeof store.getState>;
export const useAppDispatch = () => useDispatch<AppDispatch>();

export default store;
